import { useTicketList } from "@jugl-web/domain-resources/tickets/hooks/useTicketList";
import { createContext } from "react";

export type TicketSortDirection = "asc" | "desc";

export interface TicketsViewContextValue {
  ticketListQuery: ReturnType<typeof useTicketList>;
  searchQuery: string;
  sort: TicketSortDirection;
  setSearchQuery: (query: string) => void;
  setSort: (sort: TicketSortDirection) => void;
}

export const TicketsViewContext = createContext<TicketsViewContextValue | null>(
  null
);
